<template>
  <div>
    <!-- 面包屑 -->
    <bread-crumb path='其他管理' subPath='外部图片'></bread-crumb>
    <!-- 主体列表 -->
    <el-card>
      <el-row :gutter="20">
        <el-col :span="2">
          <el-button type="primary" @click="showAddDialog">添加图片</el-button>
        </el-col>
      </el-row>
    </el-card>
    <el-table :data="list" stripe border :cell-style="{ textAlign: 'center' }">
      <el-table-column prop="id" label="ID" align="center" width="50px"></el-table-column>
      <el-table-column prop="name" label="姓名" align="center"></el-table-column>
      <el-table-column prop="pic" label="图片" align="center">
        <template slot-scope="scope">
          <el-image :src="scope.row.pic+'?imageView2/0/w/50'" class="list_img"></el-image>
        </template>
      </el-table-column>
      <el-table-column prop="title" label="标题" align="center"></el-table-column>
      <el-table-column label="创建时间" align="center">
        <template slot-scope="scope">
          {{scope.row.create_time | dateTimeFormat}}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="290px">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="showEditDialog(scope.row.id)">编辑</el-button>
          <el-button type="danger" size="mini" @click="deleteRow(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="param.page"
      :page-sizes="[10, 20, 30, 40, 50]"
      :page-size="param.count"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
    <pic-outer-add :visible="addDialogAvaible"
      :id="currentId"
      @add="add"
      @update="update"
      @close="closeAddDialog">
    </pic-outer-add>
  </div>
</template>

<script>
import BreadCrumb from '../BreadCrumb.vue'
import PicOuterAdd from './PicOuterAdd.vue'
export default {
  name: 'pic_outer_list',
  components: {
    'bread-crumb': BreadCrumb,
    'pic-outer-add': PicOuterAdd
  },
  data () {
    return {
      list: [],
      currentId: 0,
      total: 0,
      pageTotal: 1,
      param: {
        page: 1,
        count: 10
      },
      addDialogAvaible: false
    }
  },
  created () {
    this.getList()
  },
  methods: {
    async getList () {
      const res = await this.$http.get('/admin/pic_outer/list', this.param)
      if (res.code === 0) {
        this.list = res.data.list
        this.total = res.data.total
        this.pageTotal = res.data.total_page
      } else {
        this.$message.error(res.msg)
      }
    },
    search () {
      this.param.page = 1
      this.getList()
    },
    handleSizeChange (size) {
      this.param.count = size
      this.getList()
    },
    handleCurrentChange (page) {
      this.param.page = page
      this.getList()
    },
    showAddDialog () {
      this.addDialogAvaible = true
    },
    closeAddDialog () {
      this.addDialogAvaible = false
      this.currentId = 0
    },
    showEditDialog (id) {
      this.currentId = id
      this.showAddDialog()
    },
    deleteRow (id) {
      this.$confirm('是否真的要删除此记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await this.$http.post('/admin/pic_outer/delete/' + id)
        if (res.code === 0) {
          this.$message.success('删除成功')
          this.getList()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(() => {})
    },
    async add (data) {
      const res = await this.$http.post('/admin/pic_outer/add', data)
      if (res.code === 0) {
        this.closeAddDialog()
        this.getList()
      } else {
        this.$message.error(res.msg)
      }
    },
    async update (id, data) {
      const res = await this.$http.post('/admin/pic_outer/update/' + id, data)
      if (res.code === 0) {
        this.closeAddDialog()
        this.getList()
      } else {
        this.$message.error(res.msg)
      }
    }
  }
}
</script>

<style scoped>
</style>
